<template>
  <Form ref="ContactForm" :model="formData" :rules="formRules" label-position="top">
    <FormItem label="Name" prop="name">
      <Input v-model="formData.name" class="k-input" />
    </FormItem>
    <FormItem label="Email address" prop="email">
      <Input v-model="formData.email" class="k-input" />
    </FormItem>
    <FormItem label="Phone number" prop="phone_number">
      <Input v-model="formData.phone_number" class="k-input" />
    </FormItem>
    <FormItem label="Company name" prop="company_name">
      <Input v-model="formData.company_name" class="k-input" />
    </FormItem>
    <FormItem label="Country" prop="country">
      <KSelect v-model="formData.country" class="k-input" classes="k-select" :optionList="countries_list" :isFilterable="true"/>
    </FormItem>
    <FormItem label="Subject" prop="subject">
      <Input v-model="formData.subject" class="k-input" />
    </FormItem>
    <FormItem label="Message" prop="message">
      <Input v-model="formData.message" type="textarea" :autosize="{minRows: 5,maxRows: 5}" class="k-input" />
    </FormItem>
    <FormItem class="no-margin">
      <p>Fields with <span style="color:#ed4014">*</span> are required</p>
      <Button class="k-btn-3" @click="handleSubmit('ContactForm')" :loading="isSending">Send message</Button>
      <Alert type="warning" show-icon class="margin-t-20 margin-b-0" v-if="formMessage">{{ formMessage }}</Alert>
    </FormItem>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </Form>
</template>

<script>
import { sendContactUs } from '@/services/contact-us'
import { mapGetters } from 'vuex'
import KSelect from '@/components/ui/Select'

export default {
  props: {
    techCompany: {
      type: Number,
      default: null
    }
  },

  components: {
    KSelect
  },

  data () {
    return {
      isLoading: false,
      isSending: false,
      formMessage: null,
      formData: {
        name: null,
        email: null,
        phone_number: null,
        company_name: null,
        country: null,
        subject: null,
        message: null,
        tech_company: this.techCompany
      },
      formRules: {
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'The email cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ],
        country: [
          { required: true, message: 'The country cannot be empty', trigger: 'blur' }
        ],
        subject: [
          { required: true, message: 'The subject cannot be empty', trigger: 'blur' }
        ],
        message: [
          { required: true, message: 'Please enter a message', trigger: 'blur' }
        ]
      }
    }
  },

  mounted () {
    if (this.getActiveUserDetails && Object.keys(this.getActiveUserDetails).length) {
      if (this.getActiveUserDetails.first_name && this.getActiveUserDetails.last_name) this.formData.name = `${this.getActiveUserDetails.first_name} ${this.getActiveUserDetails.last_name}`
      if (this.getActiveUserDetails.phone_number) this.formData.phone_number = this.getActiveUserDetails.phone_number
      if (this.getActiveUserDetails.email) this.formData.email = this.getActiveUserDetails.email
    }
  },

  computed: {
    ...mapGetters(
      {
        getActiveUserDetails: 'users/getActiveUserDetails'
      }
    )
  },

  methods: {
    sendContactUs () {
      this.isSending = true
      sendContactUs(this.formData).then(res => {
        this.$refs.ContactForm.resetFields()
        this.$Message.success('Message successfully sent.')
        this.isSending = false
      }).catch(err => {
        console.log('Failed to send contact us: ', err)
        this.isSending = false
      })
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.formMessage = null
          this.sendContactUs()
        } else {
          this.formMessage = 'One or more fields have an error. Please check and try again.'
        }
      })
    }
  }
}
</script>
